import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/List.GuestReviews';

@Injectable({
    providedIn: 'root'
})
export class ReviewService {

    refreshList = new BehaviorSubject<boolean>(false);
    closeDetails = new BehaviorSubject<boolean>(false);
    openReviewDetailsID = new BehaviorSubject<string|null>(null);
    constructor(private http: HttpClient) { }

    getAllReviews(filter: ListFilter): any {
        return this.http.post(`${environment.apiUrl}/ResReview/ListReviews`, filter);
    }
    // For Top Rates
    getTotalServiceReviews(restaurantId: any) {
        return this.http.get(`${environment.apiUrl}/ResReview/ResGetTotalServiceReviews?ResturantID=${restaurantId}`);
    }
    GetDetails(id: string, restaurantId: string): any {
        return this.http.post(`${environment.apiUrl}/ResReview/ReviewByID?ReviewsId=${id}&RestaurantId=${restaurantId}`, null);
    }
    getAll(filter: ListFilter): any {
        return this.http.post(`${environment.apiUrl}/ResReview/ResFilterReview`, filter);
    }
    ResSendReport(data: any) {
      return this.http.post(`${environment.apiUrl}/ResReview/ResSendReport`, data);
    }
}
